export const SLACK_APP_CONSTANTS = {
  authorization_url: 'https://slack.com/oauth/v2/authorize',
  redirection_url: 'https://slack.com/app_redirect',
  botScopes:
    'app_mentions:read,chat:write,files:read,files:write,im:history,im:read,im:write,mpim:history,mpim:read,team:read,channels:history',
};
